import ApiService from 'src/services/api/ApiService';

const api = ApiService.getInstance();

export const resolveShortLink = async (
  code: string,
): Promise<{ hash: string }> => {
  return api.get(`/s/${encodeURIComponent(code)}`);
};
